import {FemaGoModal, DateBoxField, Alert} from 'app-ui-componentlibrary';
import FundingOpportunityContext from './FundingOpportunityContext';
import _ from 'lodash';
import React, {useState, useContext} from 'react';
import SearchForCommitment from './SearchForCommitment';
import FundingOpportunityCommitmentDetails from './FundingOpportunityCommitmentDetails';
import {Header, Grid, Form} from 'semantic-ui-react';
import moment from 'moment-timezone';

const FOCommitmentSearchModal = ({
  isOpen,
  closeModal,
  existingCommitmentIds,
  setCommitmentToAdd,
  setIsAddCommitmentModalOpen,
}) => {
  const [isNextBtnEnabled, setIsNextBtnEnabled] = useState(false);
  const fundingOpportunity = useContext(FundingOpportunityContext);

  const handleSubmit = async () => {
    closeModal();
    setIsAddCommitmentModalOpen(true);
  };

  const handleCommitmentSelect = async (commitmentDetails) => {
    setCommitmentToAdd(commitmentDetails);
    setIsNextBtnEnabled(!_.isEmpty(commitmentDetails));
  };

  return (
    <FemaGoModal
      title="Add commitment to funding opportunity"
      open={isOpen}
      size="large"
      buttonText={'Next'}
      disableButton={!isNextBtnEnabled}
      confirmAction={handleSubmit}
      cancelAction={closeModal}
    >
      <div>
        <SearchForCommitment
          handleCommitmentSelect={handleCommitmentSelect}
          existingCommitmentIds={existingCommitmentIds}
        ></SearchForCommitment>
      </div>
    </FemaGoModal>
  );
};

export default FOCommitmentSearchModal;
